const slugify = (string: string): string => {
  return (
    string
      .trim()
      // Turn spaces and slashes into dashes.
      .replace(/[\s/]+/g, '-')
      // Remove anything but a-z, A-Z, 0-9, _, or -
      .replace(/[^\w-]+/g, '')
      // Condense multiple consecutive dashes (e.g. --)
      .replace(/--+/g, '-')
      // Lowercase what's left
      .toLowerCase()
  );
};

export default slugify;
